import React from "react";
import { Wind, ScanLine } from "lucide-react";
import LpCta from "./LpCta";
import { EXAM_CARDS } from "./lpData";

const ICONS = [Wind, ScanLine];

const LpExames = () => (
  <section className="section-pad bg-black text-white" data-testid="lp-exames">
    <div className="aevos-container">
      <div className="max-w-3xl">
        <h2 className="font-display font-bold text-3xl md:text-5xl !text-white leading-[1.08]">
          Entenda seu gasto energético e sua composição corporal
        </h2>
        <p className="mt-5 text-white/80 text-base md:text-lg leading-relaxed">
          Na AEVOS, em Mogi das Cruzes, exames e avaliações podem complementar a consulta e ajudar a
          orientar sua estratégia de emagrecimento.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {EXAM_CARDS.map((card, i) => {
          const Icon = ICONS[i];
          return (
            <article
              key={card.title}
              className="border border-white/15 hover:border-[#00C4FF] transition-colors flex flex-col"
              data-testid={`lp-exam-card-${i}`}
            >
              <img
                src={card.image}
                alt={card.alt}
                className="w-full aspect-[4/3] object-cover block"
                loading="lazy"
                draggable={false}
                data-testid={`lp-exam-image-${i}`}
              />
              <div className="p-7 md:p-8 relative">
                <span className="w-12 h-12 bg-[#00C4FF] flex items-center justify-center absolute -top-6 left-7 md:left-8">
                  <Icon size={22} className="text-black" />
                </span>
                <h3 className="font-display font-semibold text-lg md:text-xl !text-white mt-6">{card.title}</h3>
                <p className="mt-2 text-[#00C4FF] font-medium text-sm md:text-base">{card.lead}</p>
                <p className="mt-3 text-white/75 text-sm md:text-base leading-relaxed">{card.text}</p>
              </div>
            </article>
          );
        })}
      </div>

      <p className="mt-8 border-l-2 border-[#00C4FF] pl-5 text-white/80 text-sm md:text-base max-w-3xl">
        Os resultados são interpretados dentro do seu contexto clínico. A indicação de cada avaliação
        depende das suas necessidades e dos objetivos do acompanhamento.
      </p>

      <div className="mt-10">
        <LpCta location="exames">Quero saber sobre os exames</LpCta>
      </div>
    </div>
  </section>
);

export default LpExames;
